import * as authActionCreators from '../../../redux/modules/auth';

const mapStateToProps = state => ({
    language: state.auth.language,
});

const mapDispatchToProps = {
  changeLanguage:authActionCreators.changeLanguage
};

export default [mapStateToProps, mapDispatchToProps];



// WEBPACK FOOTER //
// ./src/containers/user/language/index.js